"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HookParam = exports.HookAction = exports.HOOK_ACTION_PARAMS = exports.HOOK_ACTION_METADATA = void 0;
exports.findHookActionMetadata = findHookActionMetadata;
exports.findHookActionParams = findHookActionParams;
exports.HOOK_ACTION_METADATA = Symbol('__HOOK_ACTION__');
exports.HOOK_ACTION_PARAMS = Symbol('__HOOK_ACTION_PARAMS__');
const HookAction = (hookName, options) => {
    return (target, propertyKey) => {
        const hookActionMetadata = {
            hookName,
            options,
        };
        Reflect.defineMetadata(exports.HOOK_ACTION_METADATA, hookActionMetadata, target, propertyKey);
    };
};
exports.HookAction = HookAction;
const HookParam = (name, options) => {
    return (target, propertyKey, index) => {
        let dependencies = Reflect.getMetadata(exports.HOOK_ACTION_PARAMS, target, propertyKey) || [];
        dependencies[index] = { ...options, name };
        Reflect.defineMetadata(exports.HOOK_ACTION_PARAMS, dependencies, target, propertyKey);
    };
};
exports.HookParam = HookParam;
function findHookActionMetadata(hookAction, propertyKey) {
    return Reflect.getMetadata(exports.HOOK_ACTION_METADATA, hookAction, propertyKey);
}
function findHookActionParams(hookAction, propertyKey) {
    const selfParamTypes = Reflect.getMetadata(exports.HOOK_ACTION_PARAMS, hookAction, propertyKey);
    return selfParamTypes || [];
}
//# sourceMappingURL=hookAction.decorator.js.map